import PropTypes from 'prop-types';
import React, { Component } from 'react';

import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import SwitchBtns from 'modules/Common/components/SwitchBtns';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import HorseRacingFastRacecard from '../components/HorseRacingFastRacecard';
import { metaDescription } from 'utils/seoUtils';
import { isMobile } from 'react-device-detect';
import GptAdvert from 'modules/Common/components/GptAdvert';
import _ from 'lodash';
import {singleBottomMPUProps} from "../../Common/components/GptProperties";

export default class HorseRacingFastRacecardsList extends Component {

  static propTypes = {
    isMobileFn: PropTypes.func,
    fastResults: PropTypes.shape({
      fastResults: PropTypes.arrayOf(PropTypes.shape({
        race_reference: PropTypes.shape({
          id: PropTypes.number.isRequired
        }).isRequired
      })).isRequired
    })
  };

  render() {
    require('./HorseRacingFastRacecardsList.scss');
    const metaDesc = `The latest results as they happen from Sporting Life's Fast Results service.`;
    const {
      isMobileFn = () => isMobile,
      fastResults: {fastResults: fastResultsList = []} = {}
    } = this.props;

    const isMobileSize = isMobileFn();
    const initialFastResults = isMobileSize ? fastResultsList.slice(0, 3) : fastResultsList;
    const finalFastResults = isMobileSize ? fastResultsList.slice(3) : [];

    return (
      <div className="fast-results">
        <MetaDataWrapper helmetProps={{...metaDescription(metaDesc)}} />
        <div className="fast-racecard-heading">
          <h1>Fast Results</h1>
          <SwitchBtns buttons={[
              {href: '/racing/fast-results',  text: 'UK/IRE Results', isIndex: true},
              {href: '/racing/fast-results/all', text: 'All Results'}
          ]}/>
        </div>

        <AdvertWrapper ocSlot={["racingFastResults", "leaderboard"]} additionalProperties={{ location: "/racing", view: "racing" }} />

        {(initialFastResults !== null && initialFastResults.length > 0) ?
          <div className="fast-results-list initial-fast-results">
            {initialFastResults.map(race => (
              (_.get(race, "race_reference.id")) ?
                  <HorseRacingFastRacecard key={race.race_reference.id} {...race}/>
                  :
                  <div className="fast-racecard-item failed-load">Failed to load Fast Result</div>
            ))}
          </div>
        :
          <div className="no-fast-results">No fast results.</div>
        }
        {isMobileSize &&
          <GptAdvert
            ocDetails={{
              ocSlot: ["racing", "mpu"]
            }}
            performDetails={singleBottomMPUProps}
          />
        }
        {(finalFastResults !== null && finalFastResults.length > 0) &&
          <div className="fast-results-list remaining-fast-results">
            {finalFastResults.map(race => (
              <HorseRacingFastRacecard key={race.race_reference.id} {...race}/>
            ))}
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingFastRacecardsList.js